import { createFileRoute } from '@tanstack/react-router'
import MetaDataTypes from 'Metadata/containers/MetaDataTypes'

import { Guard } from './-guard'

export const Route = createFileRoute('/metadata')({
    component: () => (
        <Guard claims={['opus_metadata']}>
            <MetaDataTypes />
        </Guard>
    ),
})
